import React from 'react'
import {Check, KeyRound} from 'lucide-react'
import * as S from './styles/authShell.styles'
import StaffologyMark from './StaffologyMark'
import type {SignInStep} from './useSignInSteps'
import {EXIT_MS, SUCCESS_HOLD_MS} from './motion'

export function AuthHandoff({direction}: Readonly<{direction: 'out' | 'back'}>) {
  return (
    <S.Handoff $direction={direction} aria-hidden="true" data-testid="auth-handoff">
      <S.Tile>
        <StaffologyMark size={36} />
      </S.Tile>
      <span className="auth-wire" />
      <S.Tile $idp>
        <KeyRound />
      </S.Tile>
    </S.Handoff>
  )
}

export function AuthProgressView({
  steps,
  fromSso,
}: Readonly<{steps: SignInStep[]; fromSso: boolean}>) {
  return (
    <S.View data-testid="auth-view-progress">
      {fromSso ? <AuthHandoff direction="back" /> : null}
      <S.CardTitle>Signing you in…</S.CardTitle>
      <S.Lede>
        {fromSso
          ? "Single Sign confirmed your account. We're setting up your workspace."
          : 'Checking your details and setting up your workspace.'}
      </S.Lede>
      <S.Steps data-testid="auth-steps">
        {steps.map((step) => (
          <S.Step
            key={step.id}
            $status={step.status}
            data-testid={`auth-step-${step.id}`}
            data-status={step.status}
            aria-current={step.status === 'active' ? 'step' : undefined}>
            <span className="auth-dot">
              <Check aria-hidden="true" />
            </span>
            {step.label}
          </S.Step>
        ))}
      </S.Steps>
    </S.View>
  )
}

export function AuthSuccessView({roleLabel}: Readonly<{roleLabel?: string}>) {
  return (
    <S.View data-testid="auth-view-success">
      <S.Badge $tone="success" aria-hidden="true">
        <Check />
      </S.Badge>
      <S.CardTitle>You&apos;re signed in</S.CardTitle>
      <S.Lede>
        {roleLabel ? `Opening your ${roleLabel} dashboard…` : 'Opening your dashboard…'}
      </S.Lede>
      <S.Progress $duration={SUCCESS_HOLD_MS + EXIT_MS} aria-hidden="true">
        <i />
      </S.Progress>
    </S.View>
  )
}
